const pronouns = [
  {
    label: 'She/Her',
    value: '1',
  },
  {
    label: 'He/Him',
    value: '2',
  },
  {
    label: 'They/Them',
    value: '3',
  },
  {
    label: 'Ze/Hir',
    value: '4',
  },
  {
    label: 'No PGP',
    value: '5',
  },
];
export default pronouns;

// SELECT
// GROUP_CONCAT(
//     CONCAT(
//         "  {\n",
//             "    label: '", label, "',\n"
//             "    value: '", `value`, "',\n"
//         '  },'
//     )
//     SEPARATOR
//     "\n"
// )
// FROM `civicrm_option_value`
// WHERE option_group_id=198